import { render, staticRenderFns } from "./AddUnitModal.vue?vue&type=template&id=5896f584&scoped=true&"
import script from "./AddUnitModal.vue?vue&type=script&lang=js&"
export * from "./AddUnitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896f584",
  null
  
)

export default component.exports